import { ModelBase } from "Core/Models";
import { action, observable } from "mobx";

export class ReservationType1FundingContactModel extends ModelBase<ReservationType1FundingContactModel, ReservationType1FundingContactDTO> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public reservationType1FundingId: string | undefined = undefined;

    @observable
    public industryContactAdditionalContactId: string | null = null;

    @observable
    public firstName: string | null = "";

    @observable
    public lastName: string | null = "";

    @observable
    public phoneNumber: string | null = "";

    @observable
    public email: string | null = "";

    @observable
    public isLender: boolean = false;

    @observable
    public dateAdded: string = "";

    @observable
    public isDeleted: boolean = false;

    @observable
    public showCopyOfReservationForm: boolean | undefined = undefined;

    @observable
    public showCopyOfMemorandumofsale: boolean | undefined = undefined;
    //#endregion Properties

    @action
    public fromDto = (dto: ReservationType1FundingContactDTO) => {
        this.id = dto.id;
        this.reservationType1FundingId = dto.reservationType1FundingId;
        this.industryContactAdditionalContactId = dto.industryContactAdditionalContactId;
        this.firstName = dto.firstName;
        this.lastName = dto.lastName;
        this.phoneNumber = dto.phoneNumber;
        this.email = dto.email;
        this.isLender = dto.isLender;
        this.dateAdded = dto.dateAdded;
        this.isDeleted = dto.isDeleted;
        this.showCopyOfReservationForm = dto.showCopyOfReservationForm;
        this.showCopyOfMemorandumofsale = dto.showCopyOfMemorandumofsale;
    };

    public toDto = (): ReservationType1FundingContactDTO => {
        return {
            id: this.id,
            reservationType1FundingId: this.reservationType1FundingId,
            industryContactAdditionalContactId: this.industryContactAdditionalContactId,
            firstName: this.firstName,
            lastName: this.lastName,
            phoneNumber: this.phoneNumber,
            email: this.email,
            isLender: this.isLender,
            dateAdded: this.dateAdded,
            isDeleted: this.isDeleted,
            showCopyOfReservationForm: this.showCopyOfReservationForm,
            showCopyOfMemorandumofsale: this.showCopyOfMemorandumofsale,
        };
    };
}

export interface ReservationType1FundingContactDTO {
    id: string | undefined;
    reservationType1FundingId: string | undefined;
    industryContactAdditionalContactId: string | null;
    firstName: string | null;
    lastName: string | null;
    phoneNumber: string | null;
    email: string | null;
    isLender: boolean;
    dateAdded: string;
    isDeleted: boolean;
    showCopyOfReservationForm?: boolean;
    showCopyOfMemorandumofsale?: boolean;
}
